import { createActions } from 'redux-actions';
import types from './types';

const { updateSettings } = createActions(types.UPDATE_SETTINGS);

export default { updateSettings };



// WEBPACK FOOTER //
// ./src/reducers/settings/actions.js